import { getApiClient } from 'adapter/out/client/apiClient';

import StoredAnalysis from 'domain/entity/storedAnalysis';
import UpdateNameStoredAnalysisCriteria from 'use-case/storedAnalysis/update/updateNameStoredAnalysisCriteria';

const updateNameStoredAnalysisApiClient = getApiClient(
    (criteria: UpdateNameStoredAnalysisCriteria) => `dashboards/stored-analyses/${criteria.id}`,
    StoredAnalysis,
    (clientCriteria: UpdateNameStoredAnalysisCriteria) => ({
        method: 'PATCH',
        body: JSON.stringify({ name: clientCriteria.name }),
        headers: { 'Content-Type': 'application/json' },
    })
);

export default updateNameStoredAnalysisApiClient;
